import React, { useEffect, useState, useCallback } from "react";
import { API_IP } from "../global_variables";
import { axiosReqConfig } from "../functions/axiosRequest";
import AddPatientModal from "./UserPatientScreen/AddPatientModal";
import "./UserPatientList.css";

const UserPatientListScreen = ({ renderPatientProfile }) => {
  const [patientsData, setPatientsData] = useState([]);
  const [isAddPatVisible, setIsAddPatVisible] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const toggleAddPatient = () => {
    setIsAddPatVisible(!isAddPatVisible);
  };

  const toggleRefresh = () => {
    setIsRefresh(!isRefresh);
  };

  const getAllPatientsData = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await axiosReqConfig(`${API_IP}/api/patients`, "get", []);
      setPatientsData(data.patients);
    } catch (error) {
      console.error("Error fetching patients data:", error);
    } finally {
      setIsLoading(false);
    }
  }, [isRefresh]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getAllPatientsData();
    }
    return () => {
      isMounted = false;
    };
  }, [getAllPatientsData]);

  return (
    <div className="UPL-container">
      <div className="UPL-header">
        <div className="UPL-header-text">
          <h2 className="UPL-title">Self/Family Members</h2>
          <p className="UPL-subtitle">
            List of all members that are associated with your account.
          </p>
        </div>
        {patientsData.length > 0 && (
          <button className="UPL-add-btn" onClick={toggleAddPatient}>
            Add New Member
          </button>
        )}
      </div>

      {isLoading ? (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "50px 0" }}>
          <img
            src={require("../images/loading_icon.gif")}
            alt="Loading members"
            style={{ width: "50px", marginBottom: "15px" }}
          />
          <span style={{ color: "#666", fontSize: "16px" }}>Loading members...</span>
        </div>
      ) : patientsData.length === 0 ? (
        <div className="UPL-empty-container">
          <div className="UPL-empty-content">
            <p className="UPL-empty-text">
              You currently do not have any member profile.
            </p>
            <button className="UPL-add-btn large" onClick={toggleAddPatient}>
              Add New Member
            </button>
          </div>
        </div>
      ) : (
        <div className="UPL-grid">
          {patientsData.map((profile, index) => {
            const imgIndex = (index % 3) + 1;
            return (
              <div
                key={index}
                className="UPL-card"
                onClick={() => {
                  renderPatientProfile(profile, imgIndex);
                }}
              >
                <div className="UPL-card-img-wrapper">
                  <img
                    src={require(
                      `../images/avatar_placeholder_${imgIndex}.png`,
                    )}
                    alt={`${profile.first_name} ${profile.last_name}`}
                    className="UPL-card-img"
                  />
                </div>
                <div className="UPL-card-content">
                  <h3 className="UPL-card-name">
                    {profile.first_name} {profile.last_name}
                  </h3>
                  <p className="UPL-card-role">Member Profile</p>
                  <div className="UPL-card-details">
                    <p className="UPL-card-info">
                      <span className="UPL-card-icon" role="img" aria-label="location">📍</span>
                      <span>{profile.city}, {profile.province}</span>
                    </p>
                    <p className="UPL-card-info">
                      <span className="UPL-card-icon" role="img" aria-label="birth year">🎂</span>
                      <span>Born in {profile.birth_year}</span>
                    </p>
                  </div>
                  <div className="UPL-card-action">
                    <span className="UPL-action-text">View Profile</span>
                    <span className="UPL-action-icon">→</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <AddPatientModal
        handleClose={toggleAddPatient}
        toggleRefresh={toggleRefresh}
        showModal={isAddPatVisible}
      />
    </div>
  );
};

export default UserPatientListScreen;
